const ArchParts4500 = (index, nodes, materials, metal, first, last, archAntiHotSpotTape, antiHotSpotTape, zigzag, cropSupportBar) => {
  let partsToShow = []

  if(archAntiHotSpotTape) {
    partsToShow.push(
      <mesh key="ANTI-HOT-TAPE015" geometry={nodes['ANTI-HOT-TAPE015'].geometry} material={materials.tape} scale={1.001}/>
    )
  }
      
  if(first || last) {
    partsToShow.push(
      <group key={`4500-arch-parts-${index}`}>
        <group name='BRACE-BAR'>
          <mesh name="PART_R32-2210-BRACE_BAR_LEFT002" geometry={nodes['PART_R32-2210-BRACE_BAR_LEFT002'].geometry} material={materials['Material_0.010']} position={last ? [-4.507, 0.33, -1.969] : [0.007, 0.33, 1.969]} rotation={last ? [2.475, -0.138, -1.325] : [0.667, 0.138, 1.817]}>
            {metal}
            <mesh name="32mm_Brace_Bracket010" geometry={nodes['32mm_Brace_Bracket010'].geometry} material={materials['Material_0.011']} position={[0.012, 0.008, 0.031]} rotation={[1.445, -0.257, -2.272]}>
              {metal}
              {/* <mesh name="Mesh_1025" geometry={nodes.Mesh_1025.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2026" geometry={nodes.Mesh_2026.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3026" geometry={nodes.Mesh_3026.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4028" geometry={nodes.Mesh_4028.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            <mesh name="32mm_Brace_Bracket011" geometry={nodes['32mm_Brace_Bracket011'].geometry} material={materials['Material_0.011']} position={[-0.017, 0.001, -2.514]} rotation={[1.908, 0.302, 0.858]}>
              {metal}
              {/* <mesh name="Mesh_1026" geometry={nodes.Mesh_1026.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2027" geometry={nodes.Mesh_2027.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3027" geometry={nodes.Mesh_3027.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4029" geometry={nodes.Mesh_4029_1.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            {
              antiHotSpotTape &&
                <mesh name="ANTI-HOT-TAPE009" geometry={nodes['ANTI-HOT-TAPE009'].geometry} material={materials.tape} scale={1.001}/>
            }
          </mesh>
          <mesh name="PART_R32-2210-BRACE_BAR_RIGHT003" geometry={nodes['PART_R32-2210-BRACE_BAR_RIGHT003'].geometry} material={materials['Material_0.010']} position={last ? [0.007, 0.33, -1.968] : [-4.507, 0.33, 1.969]} rotation={last ? [2.481, 0.133, 0.868] : [0.661, -0.133, -2.274]}>
            {metal}
            <mesh name="32mm_Brace_Bracket025" geometry={nodes['32mm_Brace_Bracket025'].geometry} material={materials['Material_0.011']} position={[-0.028, -0.012, 0.016]} rotation={[1.417, 0.71, -0.807]}>
              {metal}
              {/* <mesh name="Mesh_1027" geometry={nodes.Mesh_1027.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2028" geometry={nodes.Mesh_2028_1.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3028" geometry={nodes.Mesh_3028.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4030_1" geometry={nodes.Mesh_4030_1.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            <mesh name="32mm_Brace_Bracket026" geometry={nodes['32mm_Brace_Bracket026'].geometry} material={materials['Material_0.011']} position={[0.027, 0.008, -2.493]} rotation={[1.847, 0.205, 2.136]}>
              {metal}
              {/* <mesh name="Mesh_1029" geometry={nodes.Mesh_1029.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2029_1" geometry={nodes.Mesh_2029_1.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3029" geometry={nodes.Mesh_3029_1.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4031_1" geometry={nodes.Mesh_4031_1.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            {
              antiHotSpotTape &&
                <mesh name="ANTI-HOT-TAPE010" geometry={nodes['ANTI-HOT-TAPE010'].geometry} material={materials.tape} scale={1.001}/>
            }
          </mesh>
        </group>
        <group name="RIDGE-BRACE">
          <mesh name="PART_R32-2210-RIDGE_BRACE_LEFT" geometry={nodes['PART_R32-2210-RIDGE_BRACE_LEFT'].geometry} material={materials['Material_0.010']} position={last ? [-3.808, 2.13, -0.031] : [-0.705, 2.13, 0.03]} rotation={last ? [0.152, -0.657, -2.048] : [2.99, 0.657, 1.094]}>
            {metal}
            <mesh name="32mm_Brace_Bracket035" geometry={nodes['32mm_Brace_Bracket035'].geometry} material={materials['Material_0.011']} position={[-0.031, 0.015, 0.014]} rotation={[1.528, -0.554, -0.948]}>
              {metal}
              {/* <mesh name="Mesh_1038" geometry={nodes.Mesh_1038.geometry} material={materials['Material_1.003']} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2038" geometry={nodes.Mesh_2038.geometry} material={materials['Material_2.003']} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3037" geometry={nodes.Mesh_3037.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4039" geometry={nodes.Mesh_4039.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            <mesh name="32mm_Brace_Bracket036" geometry={nodes['32mm_Brace_Bracket036'].geometry} material={materials['Material_0.011']} position={[0.002, -0.028, -2.499]} rotation={[1.781, -0.944, 2.426]}>
              {metal}
              {/* <mesh name="Mesh_1039" geometry={nodes.Mesh_1039.geometry} material={materials['Material_1.003']} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2039_1" geometry={nodes.Mesh_2039_1.geometry} material={materials['Material_2.003']} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3038" geometry={nodes.Mesh_3038.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4040" geometry={nodes.Mesh_4040.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            {
              antiHotSpotTape &&
                <mesh name="ANTI-HOT-TAPE012" geometry={nodes['ANTI-HOT-TAPE012'].geometry} material={materials.tape} scale={1.001}/>
            }
          </mesh>
          <mesh name="PART_R32-2210-RIDGE_BRACE_RIGHT" geometry={nodes['PART_R32-2210-RIDGE_BRACE_RIGHT'].geometry} material={materials['Material_0.010']} position={last ? [-0.716, 2.136, -0.031] : [-3.798, 2.13, 0.03]} rotation={last ? [0.144, 0.652, 2.04] : [2.994, -0.652, -1.102]}>
            {metal}
            <mesh name="32mm_Brace_Bracket033" geometry={nodes['32mm_Brace_Bracket033'].geometry} material={materials['Material_0.011']} position={[0.011, 0.007, 0.03]} rotation={[1.172, 0.681, -1.924]}>
              {metal}
              {/* <mesh name="Mesh_1035" geometry={nodes.Mesh_1035.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2035" geometry={nodes.Mesh_2035.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3030_1" geometry={nodes.Mesh_3030_1.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4032_1" geometry={nodes.Mesh_4032_1.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            <mesh name="32mm_Brace_Bracket034" geometry={nodes['32mm_Brace_Bracket034'].geometry} material={materials['Material_0.011']} position={[0.02, -0.01, -2.507]} rotation={[1.533, 1.001, 0.966]}>
              {metal}
              {/* <mesh name="Mesh_1037" geometry={nodes.Mesh_1037.geometry} material={materials['Material_1.003']} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2037" geometry={nodes.Mesh_2037.geometry} material={materials['Material_2.003']} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3035" geometry={nodes.Mesh_3035.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[-Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4037" geometry={nodes.Mesh_4037.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[-Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            {
              antiHotSpotTape &&
                <mesh name="ANTI-HOT-TAPE011" geometry={nodes['ANTI-HOT-TAPE011'].geometry} material={materials.tape} scale={1.001}/>
            }
          </mesh>
        </group>
        {
          zigzag &&
            <mesh name="4500_ZIGZAG" geometry={nodes['4500_ZIGZAG'].geometry} material={materials.zigzag} position={[-11.857, 0, 0]} rotation={[-Math.PI, 1.571, 0]} />
        }
      </group>
    )
  }
  if(!first && !last && cropSupportBar) {
    partsToShow.push(
      <group name="CROP-SUPPORT-BAR" key={`4500-crop-support-bar-${index}`} position={[-1.302, 2.031, -0.003]} rotation={[-Math.PI / 2, Math.PI / 2, 0]}>
        <mesh name="PART_45R32_CROP_SUPPORT_BAR002" geometry={nodes.PART_45R32_CROP_SUPPORT_BAR002.geometry} material={materials['Material_0.016']} >
          {metal}
          <group name="Brace_Bracket_R32_with_nut_and_bolt011" position={[-0.059, 0.04, 0.726]} rotation={[Math.PI / 2, 0, -0.55]}>
            <group name="8mm_x_45mm_hex_bolt011" position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]}>
              <mesh name="Mesh_1034" geometry={nodes.Mesh_1034.geometry} material={materials['Material_1.007']} >
                {metal}
              </mesh>
              <mesh name="Mesh_2034" geometry={nodes.Mesh_2034.geometry} material={materials['Material_2.006']} >
                {metal}
              </mesh>
            </group>
            <group name="M8_nut007" position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]}>
              <mesh name="Mesh_3034" geometry={nodes.Mesh_3034.geometry} material={materials['Material_3.005']} >
                {metal}
              </mesh>
              <mesh name="Mesh_4036" geometry={nodes.Mesh_4036.geometry} material={materials['Material_2.006']} >
                {metal}
              </mesh>
            </group>
            <mesh name="32mm_Brace_Bracket032" geometry={nodes['32mm_Brace_Bracket032'].geometry} material={materials['Material_0.017']} position={[0.054, 0.025, 0.048]} rotation={[0, 0, -0.087]} >
              {metal}
            </mesh>
          </group>
          <group name="Brace_Bracket_R32_with_nut_and_bolt013" position={[-0.054, -0.048, -2.629]} rotation={[-Math.PI / 2, 0, -0.55]}>
            <mesh name="32mm_Brace_Bracket031" geometry={nodes['32mm_Brace_Bracket031'].geometry} material={materials['Material_0.017']} position={[0.022, 0.012, 0.045]} >
              {metal}
            </mesh>
            <mesh name="Mesh_1036" geometry={nodes.Mesh_1036.geometry} material={materials['Material_1.007']} position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh>
            <mesh name="Mesh_2036" geometry={nodes.Mesh_2036.geometry} material={materials['Material_2.006']} position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh>
            <mesh name="Mesh_3036" geometry={nodes.Mesh_3036.geometry} material={materials['Material_3.005']} position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh>
            <mesh name="Mesh_4038" geometry={nodes.Mesh_4038.geometry} material={materials['Material_2.006']} position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh>
          </group>
        </mesh>
      </group>
    )
  }

  return partsToShow
}

export default ArchParts4500